<template>
  <div class="businessDailyReport">
    <div class="banner">
      <img class="banner-img1" src="@/assets/images/recharge/Top01.png" @click="goToReturnPickupPrint" alt="逆向退货" />
      <img class="banner-img2" :style="{'width':drawerSize,'margin-left':marginleft,'margin-top':marginTop}"  src="@/assets/images/recharge/Content.png" alt="逆向退货" />
      <img class="banner-img1 fixed-btn"  src="@/assets/images/recharge/bottom.png" alt="逆向退货" @click="goToReturnPickupPrint" />   
    </div>
  </div>
</template>
<script>
import util from '@/utils/util';
export default {
  data() {
    return {
      drawerSize:'80%',
      marginleft:'10%',
      marginTop:'-10.7%'
    }
  },
  created() {
    this.setDrawerSize();
  },
  mounted() {
    
  },
  methods:{   
    setDrawerSize() {
      try {
        console.log('window.screen.width',window.screen.width)
          const screenWidth = window.screen.width;
          this.marginTop = '-10.7%';
          if (screenWidth >= 1280 && screenWidth <= 1440) {
            this.drawerSize = '90%';
            this.marginleft='5%';
            
          } else if (screenWidth >= 1480 && screenWidth < 1680) {
            this.drawerSize = '70%';
            this.marginleft='15%';
          } else if (screenWidth >= 1680 && screenWidth < 1920) {
            this.drawerSize = '60%';
            this.marginleft='20%';
          } else if (screenWidth >= 1920 && screenWidth < 2560) {
            this.drawerSize = '54%';
            this.marginleft='23%';
          } else if (screenWidth >= 2560 && screenWidth < 3840) {
            this.drawerSize = '40%';
            this.marginleft='30%';
          } else if (screenWidth >= 3840 && screenWidth < 5120) {
            this.drawerSize = '28%';
            this.marginleft='36%';
          } else {
            // 可以设置默认值或处理其他分辨率情况
            this.drawerSize = '70%';
            this.marginleft='15%';
          }
          
      } catch (error) {
        this.drawerSize = '70%';
        this.marginleft='15%';
      }      
    },

    goToReturnPickupPrint(){
      this.$router.push({
        path: '/dataCenter/businessData/statistic',
      })
    }
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";
.businessDailyReport {
  background-color:#F2F1FF ;
  .banner-img1{
    width: 100%;
  }
  .banner-img2{
    margin-bottom: 13.9%;
  }
  .fixed-btn{
    position: fixed;
    left: 0;
    bottom: 0;
  }
}
</style>
